import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Watch } from 'scrollmonitor-react';
import CallToAction from 'Components/CallToAction';
import FocusedImage from 'Components/FocusedImage';
import classNames from 'classnames/bind';
import styles from './styles.scss';
import AssetModel from 'Stores/AssetModel';
import ConsumptionData from 'Components/ConsumptionData';
import { getBgValue } from './getBgValue';

const cx = classNames.bind(styles);

export function GradientBox(props) {
  const image = new AssetModel(props.image);
  const { isInViewport, stopWatcher, title, text, cta1, cta2, color, consumptionText, deeplinkId } =
    props;

  const backgroundPosition = useMemo(
    () => `${getBgValue(image.focus.y, 'vertical')} ${getBgValue(image.focus.x, 'horizontal')}`,
    [image]
  );

  const { opacity, transform } = useMemo(
    () =>
      window.isPreview || isInViewport
        ? { opacity: 1, transform: 'translateY(0)' }
        : {
            opacity: 0,
            transform: 'translateY(2rem)',
          },
    [window.isPreview, isInViewport]
  );

  useEffect(() => {
    if (isInViewport) {
      stopWatcher();
    }
  }, [isInViewport]);

  return (
    <div className={cx(styles[`color--${color}`], styles.container)} id={deeplinkId}>
      <div className={cx(styles.upper)}>
        <div className={cx(styles.content)} style={{ opacity, transform }}>
          {title && (
            <h3 className={cx(styles.limiter)} dangerouslySetInnerHTML={{ __html: title }} />
          )}
          {text && (
            <section className={cx(styles.limiter)} dangerouslySetInnerHTML={{ __html: text }} />
          )}
          <div className={cx(styles.ctas)}>
            {cta1 && cta1.href && <CallToAction {...cta1} light={color === 'black'} />}
            {cta2 && cta2.href && <CallToAction {...cta2} light={color === 'black'} />}
          </div>
        </div>
        {image && (
          <div className={cx(styles.imageContainer)}>
            <img
              alt={image.alt}
              aria-description={image.description}
              className={cx(styles.image)}
              src='data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>'
              style={{
                backgroundImage: `url(${image.src})`,
                backgroundPosition,
                opacity,
              }}
              title={image.title}
            />
          </div>
        )}
      </div>
      {consumptionText && (
        <div>
          <ConsumptionData consumptionText={[consumptionText]} />
        </div>
      )}
    </div>
  );
}

GradientBox.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.shape({
    ...FocusedImage.propTypes,
  }),
  cta1: PropTypes.shape({
    ...CallToAction.propTypes,
  }),
  cta2: PropTypes.shape({
    ...CallToAction.propTypes,
  }),
  color: PropTypes.string,
};

export default Watch(GradientBox);
